<template>
    <v-sheet rounded border="sm" width="32" height="30" class="transfer-leg" :class="cssClasses">
        <div v-if="!hideDuration" class="transfer-leg__duration">
            {{ remainingTimeInMinutes }}
        </div>
        <v-sheet color="transparent" width="18">
            <v-icon :icon="icon" size="24" class="transfer-leg__icon" :color="color" />
        </v-sheet>
    </v-sheet>
</template>

<script setup lang="ts">
import { secondsToClosestMinutes } from '@/features/common/helpers';
import { computed } from 'vue';

interface Props {
    /** The icon to display */
    icon?: string;

    /** The color of the icon */
    color?: string;

    /** The duration of the leg in seconds */
    duration?: number;

    /** Whether to hide the duration */
    hideDuration?: boolean;
}

const props = withDefaults(defineProps<Props>(), { icon: 'kdi-foot', color: 'grey-darken-1', duration: 0 });
const cssClasses = computed(() => ({
    'transfer-leg--centered': props.hideDuration
}));
const remainingTimeInMinutes = computed(() => Math.max(1, secondsToClosestMinutes(props.duration ?? 0)));
</script>

<style lang="scss">
@use 'vuetify/settings' as *;
@use 'vuetify/lib/styles/tools/index' as tools;

.transfer-leg {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0 3px;

    &--centered {
        justify-content: center;
    }

    &__duration {
        position: absolute;
        top: 1px;
        right: 3px;
        text-align: right;
        @include tools.typography(10px, 400, -1px, 1, none);
    }

    &__icon {
        margin-left: -3px;
        color: var(--v-color-grey-darken-1);
    }
}
</style>
